import React from 'react';
import { withTranslation as originalTranslate } from 'react-i18next';
import { compose } from 'recompose';
import moment from 'moment';

const loc = moment.locale();
moment.locale('ru');
moment.updateLocale('ru', {
  monthsShort: moment.monthsShort().map(month => month.substr(0, 3))
});
moment.locale(loc);

const translateMultilang = (value, language) => {
  return language in value ? value[language] : '';
};

const extendTranslate = BaseComponent => ({ t, ...props }) => {
  // debugger;
  return (
    <BaseComponent
      {...props}
      t={(key, ...ops) =>
        key && key.isMultilang ? translateMultilang(key, props.i18n.language) : t(key, ...ops)
      }
      lng={props.i18n.language || 'en'}
    />
  );
};

export const translate = compose(originalTranslate('utcom'), extendTranslate);



// WEBPACK FOOTER //
// ./src/utils/translateUtils.js